







































































































































































































































































































































































































































import Vue from "vue";
import store from "../services/RiportStore";
import eventBus from "@/services/eventBus";
import { Grid } from "@progress/kendo-vue-grid";
import IconButton from "@/components/IconButton.vue";
import CheckBox from "@/components/CheckBox.vue";

export default Vue.extend({
  components: { Grid, IconButton, CheckBox },
  data() {
    return {
      store,
      // Aktív fül + fülváltás-animáció iránya (a jóváhagyott GL tab-minta)
      tabIndex: 0,
      slideClass: "",
      // A fülek: a korábbi szekció-címek; a magyarázat a fül tooltipjében.
      defTabs: [
        { title: "Riport", description: "A riport-definíciók (fejek) listája — itt választod ki, melyik riportot szerkeszted", needsHead: false },
        { title: "Főcsoportok", description: "A kiválasztott riport főcsoportjai", needsHead: true },
        { title: "Elemek", description: "A kiválasztott főcsoport értékébe +/- előjellel beszámító hivatkozott csomópontok", needsHead: true },
        { title: "Csoportok", description: "A kiválasztott főcsoport csoportjai", needsHead: true },
        { title: "Sorok", description: "A kiválasztott csoport sorai", needsHead: true },
        { title: "Sortételek (maszkok)", description: "A kiválasztott sor tételei: főkönyvi szám- és dimenzió-maszkok", needsHead: true },
      ],
      // A riport fejek (hmbokrephead) tábla oszlopai – a v-select helyett.
      headColumns: [
        { cell: "deleteCell", title: "", width: "100px", filterable: false, sortable: false },
        { field: "name", title: "Megnevezés", cell: "textCell" },
        { field: "natLong", title: "Hosszú név", cell: "textCell" },
        { field: "year", title: "Könyvelési év", width: "160px", cell: "headYearCell" },
        { field: "carType", title: "Gépjármű típus", width: "160px", cell: "textCell" },
        { filterable: false, width: 0 },
      ],
      // K2D w_repheads node-grid oszlopsorrend: sign, code, national, nat_long, empty_in_rep, item_visible, order_no, is_code, is_bold, is_italic, eject_after
      nodeColumns: [
        { cell: "deleteCell", title: "", width: "100px", filterable: false, sortable: false },
        { field: "orderNo", title: "#", width: "160px", cell: "numberCell" },
        { field: "sign", title: "Előjel", width: "160px", cell: "signCell" },
        { field: "code", title: "Kód", width: "110px", cell: "textCell" },
        { field: "name", title: "Megnevezés", cell: "textCell" },
        { field: "emptyInRep", cell: "boolCell", title: "Üres", width: "100px", headerClassName: "center_text" },
        { field: "itemVisible", cell: "boolCell", title: "Tételek láthatóak", width: "140px", headerClassName: "center_text" },
        { field: "isCode", cell: "boolCell", title: "Kód látszik", width: "120px", headerClassName: "center_text" },
        { field: "isBold", cell: "boolCell", title: "Kiemelt", width: "90px", headerClassName: "center_text" },
        { field: "isItalic", cell: "boolCell", title: "Dőlt", width: "70px", headerClassName: "center_text" },
        { field: "ejectAfter", cell: "boolCell", title: "Lapdobás", width: "90px", headerClassName: "center_text" },
        { filterable: false, width: 0 },
      ],
      // K2D w_repheads sortétel-grid oszlopsorrend: sign, national, is_balance, acc_sign, accno, dimcode1..9, rowtype, total, is_balance_sign, year
      rowItemColumns: [
        { cell: "deleteCell", title: "", width: "100px", filterable: false, sortable: false },
        { field: "sign", cell: "boolCell", title: "Előjel", width: "160px", headerClassName: "center_text" },
        { field: "name", title: "Sortétel megnevezés", cell: "textCell", width: "200px" },
        { field: "isBalance", cell: "boolCell", title: "Egyenleg", width: "90px", headerClassName: "center_text" },
        { field: "accSign", cell: "accSignCell", title: "Oldal", width: "120px" },
        { field: "accNo", title: "Főkönyvi szám maszk", cell: "textCell", width: "150px" },
        { field: "dimcode1", title: "Dim 1", width: "90px", cell: "textCell" },
        { field: "dimcode2", title: "Dim 2", width: "90px", cell: "textCell" },
        { field: "dimcode3", title: "Dim 3", width: "90px", cell: "textCell" },
        { field: "dimcode4", title: "Dim 4", width: "90px", cell: "textCell" },
        { field: "dimcode5", title: "Dim 5", width: "90px", cell: "textCell" },
        { field: "dimcode6", title: "Dim 6", width: "90px", cell: "textCell" },
        { field: "dimcode7", title: "Dim 7", width: "90px", cell: "textCell" },
        { field: "dimcode8", title: "Dim 8", width: "90px", cell: "textCell" },
        { field: "dimcode9", title: "Dim 9", width: "90px", cell: "textCell" },
        { field: "rowType", cell: "rowTypeCell", title: "Sortípus", width: "150px" },
        { field: "total", title: "Összeg", width: "110px", cell: "numberCell", className: "right_text" },
        { field: "isBalanceSign", cell: "boolCell", title: "Egyenleg előjel", width: "120px" },
        { field: "year", cell: "yearCell", title: "Év", width: "130px" },
        { filterable: false, width: 0 },
      ],
      // K2D dw_item: hivatkozott csomópontok + előjel (nincs order_no, fizikai törlés)
      mainItemColumns: [
        { cell: "deleteCell", title: "", width: "100px", filterable: false, sortable: false },
        { field: "sign", title: "Előjel", width: "160px", cell: "itemSignCell" },
        { field: "repMainGroup", cell: "refMainGroupCell", title: "Hivatkozott főcsoport" },
        { field: "repGroup", cell: "refGroupCell", title: "Hivatkozott csoport" },
        { field: "repRow", cell: "refRowCell", title: "Hivatkozott sor" },
        { filterable: false, width: 0 },
      ],
    };
  },
  computed: {
    selectedHead(): any {
      return this.store.heads.find((h: any) => h.id === this.store.selectedHeadId) || null;
    },
    // A Főcsoportok fül kontextus-felirata: melyik riport miatt látszik ez a lista.
    headCaption(): string {
      return this.selectedHead ? `– ${this.selectedHead.name}` : "– előbb válassz riportot";
    },
    yearItems(): any[] {
      return this.store.years.map((y: any) => ({ id: y.id, label: y.name || String(y.year) }));
    },
    // Sortétel "Oldal" oszlop (imbokreprowitem.acc_sign): true = Tartozik, false = Követel.
    accSignItems(): any[] {
      return [
        { text: "Tartozik", value: true },
        { text: "Követel", value: false },
      ];
    },
    // Az "elem" hivatkozás-legördülői: a fej csomópontjai + egy "— (nincs)" (id=1) opció.
    refMainGroupItems(): any[] {
      return [{ id: 1, name: "— (nincs)" }, ...this.store.mainGroups];
    },
    refGroupItems(): any[] {
      return [{ id: 1, name: "— (nincs)" }, ...this.store.allGroups];
    },
    refRowItems(): any[] {
      return [{ id: 1, name: "— (nincs)" }, ...this.store.allRows];
    },
    // A három node-grid közös nodeColumns-a, szintenként eltérő "Megnevezés" fejléccel.
    mainGroupColumns(): any[] {
      // "Kód látszik" főcsoport-szinten "Főcsop. kód látszik" (a K2D d_g_imbokrepmaingroup magyar felirata).
      return this.nodeColumns.map((c: any) => {
        if (c.field === "name") return { ...c, title: "Főcsoport megnevezés" };
        if (c.field === "isCode") return { ...c, title: "Főcsop. kód látszik", width: "150px" };
        return c;
      });
    },
    groupColumns(): any[] {
      return this.nodeColumns.map((c: any) => {
        if (c.field === "name") return { ...c, title: "Csoport megnevezés" };
        if (c.field === "isCode") return { ...c, title: "Csop. kód látszik", width: "150px" };
        return c;
      });
    },
    rowColumns(): any[] {
      // A RiportRow modellnek (a Főcsoport/Csoport szinttel ellentétben) NINCS itemVisible mezője
      // (ld. a szerkesztő-form v-if="level !== 'row'" kizárását) — a közös nodeColumns-ból ezért
      // itt ki kell szűrni, különben egy sosem-perzisztálódó "szellem" checkbox jelenne meg.
      return this.nodeColumns
        .filter((c: any) => c.field !== "itemVisible")
        .map((c: any) => {
          if (c.field === "name") return { ...c, title: "Sor megnevezése" };
          if (c.field === "isCode") return { ...c, title: "Sor kód látszik", width: "150px" };
          return c;
        });
    },
  },
  watch: {
    "store.selectedType"() {
      this.store.onTypeChanged();
    },
    "store.selectedHeadId"() {
      this.store.onHeadChanged();
    },
    "store.onlyLive"() {
      this.store.onOnlyLiveChanged();
    },
    // Fülváltás iránya szerinti csúszó animáció a tartalomdobozon
    tabIndex(val: number, old: number) {
      this.slideClass = val > old ? "slide-from-right" : "slide-from-left";
    },
  },
  async mounted() {
    // A store singleton túléli a navigációt: ha már be van töltve (visszatérés a szerkesztőből),
    // a kiválasztások és a listák megmaradnak. Csak az első belépéskor töltünk törzsadatot.
    if (!this.store.types.length) {
      await this.store.loadLookups();
    }
  },
  methods: {
    // A szinthez tartozó (grid által mutatott) store-lista.
    listForLevel(level: string): any[] {
      switch (level) {
        case "head": return this.store.heads;
        case "maingroup": return this.store.mainGroups;
        case "mainitem": return this.store.mainItems;
        case "group": return this.store.groups;
        case "row": return this.store.rows;
        case "rowitem": return this.store.rowItems;
        default: return [];
      }
    },
    // "Új ...": üres, azonnal szerkeszthető sor a grid tetejére (egyszerre csak egy új sor lehet).
    addNew(level: string) {
      const arr = this.listForLevel(level);
      if (arr.some((x: any) => x.id === 0)) return;
      arr.unshift({ ...this.store.blankModel(level), deleting: false, selected: false, inEdit: true });
    },
    // Inline szerkesztés indítása: pillanatkép a Mégséhez, majd a cellák szerkeszthetőre váltanak.
    // A szerkesztésre nyitott sor egyben KIVÁLASZTOTT sorrá is válik (szerkesztés közben a
    // cellák input-kattintásai stopolva vannak, sor-kattintással már nem lehetne kijelölni).
    startEdit(level: string, item: any) {
      (item as any)._backup = { ...item };
      this.$set(item, "inEdit", true);
      if (item.id) this.selectByLevel(level, item.id);
    },
    // Szint szerinti kiválasztás (a store megfelelő select metódusa).
    selectByLevel(level: string, id: number) {
      switch (level) {
        case "head": this.store.selectHead(id); break;
        case "maingroup": this.store.selectMainGroup(id); break;
        case "mainitem": this.store.selectMainItem(id); break;
        case "group": this.store.selectGroup(id); break;
        case "row": this.store.selectRow(id); break;
        case "rowitem": this.store.selectRowItem(id); break;
      }
    },
    // Mégse: új (még nem mentett) sor eldobása, meglévőnél az eredeti értékek visszaállítása.
    cancelEdit(level: string, item: any) {
      const arr = this.listForLevel(level);
      if (!item.id) {
        const idx = arr.indexOf(item);
        if (idx >= 0) arr.splice(idx, 1);
        return;
      }
      const backup = (item as any)._backup;
      if (backup) {
        // Csak a mezőértékek állnak vissza — a UI-állapotok (selected/deleting/inEdit) nem,
        // különben a pillanatkép-beli selected=true visszaíródna, és két kék sor lenne.
        delete backup.selected;
        delete backup.deleting;
        delete backup.inEdit;
        delete backup._backup;
        Object.assign(item, backup);
      }
      this.$set(item, "inEdit", false);
    },
    // Mentés: a sor tartalma megy a meglévő persist végpontra, majd a szint újratöltődik a DB-ből.
    async saveEdit(level: string, item: any) {
      this.store.busy = true;
      try {
        const model: any = { ...item };
        delete model.inEdit;
        delete model.deleting;
        delete model.selected;
        delete model._backup;
        await this.store.persist(level, model);
        eventBus.$emit("success", "Sikeres mentés!");
        await this.store.reload(level);
      } catch (e) {
        eventBus.$emit("error", "A mentés nem sikerült!");
      } finally {
        this.store.busy = false;
      }
    },
    // Bool cella írása (Vue reaktivitáshoz $set).
    setField(item: any, field: string, value: any) {
      this.$set(item, field, value);
    },
    // Sor-kiválasztás: csak a még mentetlen ÚJ sorra (id=0) nem váltunk kontextust — a meglévő,
    // épp szerkesztett sor visszajelölhető (a szerkesztés-állapotát a kattintás nem bántja).
    selectHead(e: any) {
      if (e.dataItem.inEdit && !e.dataItem.id) return;
      this.store.selectHead(e.dataItem.id);
    },
    selectMainGroup(e: any) {
      if (e.dataItem.inEdit && !e.dataItem.id) return;
      this.store.selectMainGroup(e.dataItem.id);
    },
    selectGroup(e: any) {
      if (e.dataItem.inEdit && !e.dataItem.id) return;
      this.store.selectGroup(e.dataItem.id);
    },
    selectRow(e: any) {
      if (e.dataItem.inEdit && !e.dataItem.id) return;
      this.store.selectRow(e.dataItem.id);
    },
    selectRowItem(e: any) {
      if (e.dataItem.inEdit && !e.dataItem.id) return;
      this.store.selectRowItem(e.dataItem.id);
    },
    selectMainItem(e: any) {
      if (e.dataItem.inEdit && !e.dataItem.id) return;
      this.store.selectMainItem(e.dataItem.id);
    },
    parentName(arr: any[], id: number | null): string {
      const p = arr.find((x) => x.id === id);
      return p ? `– ${p.name || p.code || ""}` : "";
    },
    // Egy hivatkozott csomópont megjelenítendő neve (id <= 1 → "-" = nincs).
    nodeName(arr: any[], id: number): string {
      if (!id || id <= 1) return "-";
      const n = arr.find((x: any) => x.id === id);
      if (!n) return "-";
      return n.code ? `${n.code} – ${n.name}` : n.name;
    },
    // Sortétel-grid lookup oszlopok: id → megjelenítendő szöveg.
    rowTypeName(id: number): string {
      const rt = this.store.rowTypes.find((r: any) => r.id === id);
      return rt ? rt.name : "";
    },
    yearLabel(id: number): string {
      const y = this.store.years.find((yy: any) => yy.id === id);
      return y ? (y.name || String(y.year)) : "";
    },
    // A "Csak élők" kikapcsolva a törölt (deleted) sorokat is mutatja – halványítva, áthúzva.
    rowRender(h: any, trElement: any, _defaultSlots: any, props: any): any {
      return h(
        trElement.tag,
        {
          ...trElement.data,
          class: [trElement.data && trElement.data.class, props.dataItem.deleted ? "deleted-row" : ""],
        },
        trElement.children
      );
    },
    // Táblánkénti (soron belüli) törlés: a sor alatt kinyíló sárga megerősítő detail-sor.
    toggleExpandRow(item: any, refName: string) {
      item.deleting = !item.deleting;
      this.$nextTick(() => {
        const grid = this.$refs[refName] as any;
        const detailCell = grid && grid.$el ? grid.$el.querySelector(".k-detail-cell") : null;
        if (detailCell) {
          detailCell.style.position = "sticky";
          detailCell.style.left = "0px";
        }
      });
    },
  },
});
